import _ from "lodash";
import moment from "moment";
import { IKeyValueLogsState } from "source/app/presentation/MainPanel/KeyValueLogs/IKeyValueLogsState";
import { Emotions } from "source/app/domain/Emotions/Emotions";
import { IKeyValueLog } from "motw_core/Entity/IKeyValueLog";
import { IRecentEmotionValuePerDay } from "./IRecentEmotionValuePerDay";

export function GetRecentEmotionsValuesPerDay(kvLogs: IKeyValueLog[]) {
    const sortedKvLogs = _.sortBy(kvLogs, (kvLogEntry) =>
        moment(kvLogEntry.lastmodifiedtime).valueOf()
    );

    if (sortedKvLogs.length < 2) {
        return undefined;
    }

    const firstEntry = sortedKvLogs[0];
    const lastEntry = sortedKvLogs[sortedKvLogs.length - 1];

    const numHours = moment(lastEntry.lastmodifiedtime).diff(
        moment(firstEntry.lastmodifiedtime),
        "hours"
    );

    const valuePerDay_I = GetValuePerDay(
        sortedKvLogs,
        Emotions.Integrated.character,
        numHours
    );

    const valuePerDay_P = GetValuePerDay(
        sortedKvLogs,
        Emotions.Peace.character,
        numHours
    );

    return [valuePerDay_I, valuePerDay_P];
}

function GetValuePerDay(
    sortedKvLogs: IKeyValueLog[],
    emotionCharacter: string,
    numHours: number
) {
    const numEntries = sortedKvLogs.filter(
        (row) => row.value === emotionCharacter
    ).length;

    const numDays = numHours / 24;
    const valuePerDay = parseFloat((numEntries / numDays).toFixed(1));

    const result: IRecentEmotionValuePerDay = {
        emotionCharacter,
        numEntries,
        valuePerDay,
    };

    return result;
}
